<template>
    <div class="clueManagement">
		<leftnav class="fl" mkcode="A" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox">
					<div class="py-3">
                        <table border="0" cellspacing="0" cellpadding="0" class="land_table">
							<tr>
								<th>序号</th>
                                <th>行政区</th>
								<th>项目名称</th>
								<th>总面积</th>
                                <th>土地用途</th>
                                <th>土地使用权人（项目公司）</th>
								<th>投资主体</th>
                                <th >投资来源地</th>
                                <th >签订日期</th>
                                <th >操作</th>
							</tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.region}}</td>
                                <td class="title" @click="handlerLinkLocal('/landDetail?id='+item.id)">{{item.projectname}}</td>
                                <td>{{item.totalarea}}</td>
                                <td>{{item.landuse}}</td>
                                <td class="title" @click="routerlinkid('/enterprises?id='+item.stockcode)">{{item.company}}</td>
                                <td>{{item.investor}}</td>
                                <td>{{item.source}}</td>
                                <td>{{item.signDate}}</td>
                                <td class="collectfont1">
                                    <span @click="delClue(item)">移除线索管理</span>
                                </td>
                            </tr>
                    </table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script> 
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'clueManagement',
    computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
    data() {
        return {
            userdata: {},
            page: 1,
            haspage: true,
            pageSize: 10,
            total: 0,
            totalPage: 1,
            maxPage: 10,
            yj_itemcode: "A01",
            enterpristlist: [{
                col:1,
                stockcode: '1',
                region: '河北省秦皇岛市',
                projectname: '秦皇岛海港区盛步储能技术有限公司',
                totalarea: '44.72', 
                landuse: '仓储用地', 
                company: '秦皇岛海港区盛步储能技术有限公司', 
                investor: '晶科电力有限公司', 
                source: '浙江省嘉兴市', 
                signDate: '2025-11-25' 
                }],
        };
    },
    methods: {
        ajaxsearchcompany(page) {
            console.log('ajaxsearchcompany', page);
        },
        delClue(item) {
            console.log('移除线索管理', item);
        },
        pageHandler(page) {
            this.page = page;
            // this.ajaxsearchcompany(page);
        },
    },
};
</script>
<style>
.clueManagement .whitebox{
    min-height: 95vh;
}
</style>